import loadable from "@loadable/component";
import CreateIcon from "../../Icons/Create";
import APIS from "../../constant/EndPoint";
import { useParams } from "react-router";
import usePatchHook from "../../customHooks/useUserServicePatchHook";
import useGetHook from "../../customHooks/useUserServiceGetHook";
import Spinner from "../../components/Reusable/Spinner";

const UpdateRoleComponent = loadable(
  () => import("../../components/Auth/UpdateRole")
);
const UpdateRole = () => {
  const { id } = useParams()

  const { data, isLoading } = useGetHook({
    queryKey: [`role-${id}`],
    url: `${APIS.GROUP}${id}/`,
    params: {},
  });

  const { data: userPermissions } = useGetHook({
    queryKey: [`userPermissions`],
    url: `${APIS.PERMISSIONS}user_management/`,
    params: {},
  });

  const { data:logesticPermissions } = useGetHook({
    queryKey: [`logesticPermissions`],
    url: `${APIS.PERMISSIONS}logistic/`,
    params: {},
  });


  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["roles", `role-${id}`],
    navigateURL: "/roles",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.GROUP}${id}/`;
    let formData = {
      ...values,
      group_name:values?.role,
      name:values?.role
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Edit Role</span>
      </div>
      {isLoading ? <Spinner /> :
        <UpdateRoleComponent
          isLoading={isPatchLoading}
          handleEdit={handleEdit}
          data={data}
          userPermissions={userPermissions}
          logesticPermissions={logesticPermissions}
        />
      }
    </>
  );
};

export default UpdateRole